import { render } from "./CTextarea.vue?vue&type=template&id=d1f68c66"
import script from "./CTextarea.vue?vue&type=script&lang=js"
export * from "./CTextarea.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__